import React from 'react';

import { trans } from '../../../../../localization/index';
import Modal, {
  ModalAction,
  ModalBody,
  ModalButton,
  ModalHeader,
} from '../../../../../components/Modal/Modal';
import { formatTimeDateView } from '../../../../../utils/utils';
import { EnumRejectOrderReason } from '../../../../../constants/enum';

function RejectOrderRestaurantCloseModal({
  isOpenDialog,
  nextOpenTime,
  handleRejectOrder,
  handleUpdateOrder,
}) {
  return (
    <Modal isOpen={isOpenDialog} className="out-of-stock-dish-modal">
      <ModalHeader closeButton>{trans('mod_restaurant_close')}</ModalHeader>
      <ModalBody>
        <div style={{ margin: 10 }}>
          {`${trans(
            'mod_reject_your_shop_will_be_closed_until',
          )} ${formatTimeDateView(nextOpenTime)}. ${trans(
            'mod_reject_are_you_sure',
          )}`}
        </div>
      </ModalBody>
      <ModalAction>
        <ModalButton onClick={handleUpdateOrder}>
          {trans('common_yes')}
        </ModalButton>
        <ModalButton
          type="cancel"
          onClick={() =>
            handleRejectOrder(EnumRejectOrderReason.CHOOSE_OPTION.id)
          }
        >
          {trans('mod_go_back')}
        </ModalButton>
      </ModalAction>
    </Modal>
  );
}

export default RejectOrderRestaurantCloseModal;



// WEBPACK FOOTER //
// ./foody/src/pages/Order/OrderManagement/OrderDetail/RejectOrder/RejectOrderRestaurantCloseModal.jsx